import { render, staticRenderFns } from "./SwapReviewStep.vue?vue&type=template&id=beab6c42&scoped=true"
import script from "./SwapReviewStep.vue?vue&type=script&lang=ts"
export * from "./SwapReviewStep.vue?vue&type=script&lang=ts"
import style0 from "./SwapReviewStep.vue?vue&type=style&index=0&id=beab6c42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beab6c42",
  null
  
)

export default component.exports